import React from 'react';
import FooterHeader from './FooterHeader';
import FooterColumns from './FooterColumns';
import FooterBottom from './FooterBottom';

const Footer = ({
  bgColor = 'bg-[#6440FB]',
  textColor = 'text-white',
  borderColor = 'border-white/20',
  logo
}) => {
  return (
    <footer className={`${bgColor} ${textColor} px-4 sm:px-8 lg:px-16 xl:px-[105.5px]`}>
      <div className="container mx-auto py-8 sm:py-12">
        <FooterHeader logo={logo} textColor={textColor} borderColor={borderColor} />
        <FooterColumns textColor={textColor} borderColor={borderColor} />
        <FooterBottom textColor={textColor} borderColor={borderColor} />
      </div>
    </footer>
  );
};

export default Footer;